module.exports = __webpack_public_path__ + "static/img/SuportdArrel-net.7c2bd0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SuportdArrel-net.png
// module id = xbBA
// module chunks = 1